import { useLayoutEffect, useRef } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Po prechode na inú stránku začína nová stránka hore.
 *
 * PREČO TO TREBA:
 *   SPA pri zmene cesty nič nenačítava, takže prehliadač nemá dôvod posunúť
 *   stránku -- človek odskrolovaný dole na dennom menu klikol na Kontakt
 *   a ocitol sa v strede kontaktu (alebo pod ním, pri kratšej stránke).
 *
 * KEDY NIE:
 *   - Späť/Dopredu (POP): tam sa človek chce vrátiť tam, kde bol.
 *   - Zmena len query (`?prihlasenie`, `?den=`): je to stále tá istá
 *     stránka, skok nahor by bol rušivý. Preto sa sleduje iba `pathname`.
 *
 * `useLayoutEffect`, aby sa nová stránka nevykreslila na sekundu
 * v starej polohe a až potom neskočila.
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const predosla = useRef(pathname);

  useLayoutEffect(() => {
    if (predosla.current === pathname) return;
    predosla.current = pathname;
    if (navigationType === "POP") return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, navigationType]);

  return null;
}

export default ScrollToTop;
